import React, { useMemo, useState, useEffect } from 'react';
import StickyTitle from '../components/StickyTitle.js';
import { MaterialReactTable } from 'material-react-table';
import { Button } from '@mui/material';
import NewExpenseForm from '../components/NewExpenseForm.js';
import axios from "axios";
import { CSVLink } from "react-csv";
import { useAuth } from '../../AuthContext.js';
import NewPurchaseForm from '../components/NewPurchaseForm.js';
import { Box, IconButton } from '@mui/material';
import ReceiptIcon from '@mui/icons-material/Receipt';
import defaultLogoUrl from "../../assets/company.png"
import PurchaseRec from "../components/PurchaseRec.js"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PurchasesPage = () => {

  const { userRole } = useAuth()
  const [employee, setEmployee] = useState(true);

  useEffect(() => {
    if (userRole === "manager") {
      setEmployee(false)
    } else {
      setEmployee(true)
    };
  }, [userRole])

  let [selectedRow, setSelectedRow] = useState(null);
  let [selectedRowData, setSelectedRowData] = useState(null);
  let [selectedRowDataPreview, setSelectedRowDataPreview] = useState(null);
  let [isPopupOpen, setIsPopupOpen] = useState(null);

  const [isNewExpenseFormOpen, setisNewExpenseFormOpen] = useState(false);
  const [showPopup, setshowPopup] = useState(false);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [expenseData, setExpenseData] = useState([]);
  const [purchaseData, setpurchaseData] = useState([]);

  const togglePopup = () => {
    setshowPopup(!showPopup)
  }

  const openNewExpenseForm = () => {
    setisNewExpenseFormOpen(true);
    setSelectedRowData(null);
  };

  const closeNewExpenseForm = () => {
    setisNewExpenseFormOpen(false);
  };

  useEffect(() => {
    const fetch_expenses = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/expenses/all_expenses`);
        const responseData = await response.json();
        if (responseData) {
          setExpenseData(responseData.expense);
          setData2(responseData.expense)
        }
      } catch (error) {
        // Handle errors here
        console.error("Error fetching data:", error);
      }
    }
    const fetch_purchases = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/purchases/all_purchases`);
        const responseData = await response.json();
        if (responseData) {
          setpurchaseData(responseData);
          setData1(responseData)
        }
      } catch (error) {
        // Handle errors here
        console.error("Error fetching data:", error);
      }
    }
    fetch_expenses();
    fetch_purchases();
  }, [isNewExpenseFormOpen,showPopup])

  const delete_expense = async (id) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/expenses/delete_expense`, {
        data: {
          id: id
        }
      })
      if (response.status === 200) {
        toast.success(`Expense with id: "${id}" deleted successfully.`)
      }
    } catch (error) {
      toast.error("Error deleting expense")
    }
  }

  const delete_purchase = async (id) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/purchases/del_purchases`, {
        data: {
          purchaseId: id
        }
      })
      if (response.status === 200) {
        toast.success(`Purchase with id: "${id}" deleted successfully.`)
      }
    } catch (error) {
      toast.error("Error deleting purchase")
    }
  }

  const columns2 = useMemo(
    () => [
      {
        accessorKey: 'id', //access nested data with dot notation
        header: 'ID',
        size: 100,
      },
      {
        accessorKey: 'title', //access nested data with dot notation
        header: 'Title',
        size: 100,
      },
      {
        accessorKey: 'amount',
        header: ' Amount',
        size: 100,
      },
      {
        accessorKey: 'expensedate',
        header: ' Expense Date',
        size: 100,
      },
    ],
    [],
  );

  const columns = useMemo(
    () => [
      {
        accessorKey: 'purchase_number',
        header: 'Purchase Number',
        size: 100,
      },
      {
        accessorKey: 'vendor',
        header: 'Vendor',
        size: 100,
      },
      {
        accessorKey: 'purchase_date',
        header: 'Purchase Date',
        size: 100,
        Cell: ({ cell }) => {
          return <span>{new Date(cell.getValue()).toISOString().slice(0, 10)}</span>;
        },
      },
    ], [],
  )

  return (
    <>
      <StickyTitle title="Purchases/Expenses" button_action={togglePopup} button="New Purchase" multibutton={true} button_action2={openNewExpenseForm} button2="New Expense" />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className=' px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-0'>
        <div className="table-filters flex flex-row items-center justify-between mb-5">
          <div className='text-2xl font-bold font-poppins'>Purchases</div>
        </div>

        <div className="mb-10">
          <MaterialReactTable
            enableRowActions
            enableRowSelection
            columns={columns}
            data={purchaseData}
            renderRowActions={({ row }) => (
              <Box>
                <IconButton onClick={() => {
                  let rowData = row.original;
                  setSelectedRowDataPreview(rowData)
                  setIsPopupOpen(true);
                }}>
                  <ReceiptIcon />
                </IconButton>
              </Box>
            )}
            renderTopToolbarCustomActions={({ table }) => {
              const handleDelete = () => {
                const selectedRows = table.getSelectedRowModel().flatRows;

                if (selectedRows.length === 1) {
                  selectedRow = selectedRows[0];
                  const selectedRowId = selectedRow.original.id;
                  setSelectedRow(selectedRow);
                  alert('Deleting purchase with ID: ' + selectedRowId);
                  delete_purchase(selectedRowId)
                } else {
                  alert('Please select a single row to delete.');
                }
              };

              return (
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <Button
                    color="error"
                    disabled={!table.getIsSomeRowsSelected()}
                    onClick={handleDelete}
                    variant="contained"
                    sx={employee ? { display: 'none' } : {}}

                  >
                    Delete
                  </Button>
                  <Button
                    color="success"
                    variant="contained"
                  >
                    <CSVLink data={data1}>Export to CSV</CSVLink>
                  </Button>
                </div>
              );
            }}
          />
        </div>

        <div>
          {isPopupOpen && (
            <div style={{
              display: isPopupOpen ? 'block' : 'none',
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              padding: '20px',
              boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
              zIndex: '999',
              height: '90vh',
              overflowY: 'auto',
              width: '800px'
            }}>

              <button
                className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 bg-transparent border-5 border-black"
                onClick={() => setIsPopupOpen(false)}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              <PurchaseRec
                companylogo={defaultLogoUrl}
                vendorname={selectedRowDataPreview.vendor}
                vendorlpo={selectedRowDataPreview.vendorlpo}
                vendoraddress={selectedRowDataPreview.vendoraddress}
                vendorphone={selectedRowDataPreview.vendorphone}
                purchase_number={selectedRowDataPreview.purchase_number}
                purchase_date={selectedRowDataPreview.purchase_date}
                time={selectedRowDataPreview.time}
                list={selectedRowDataPreview.list}
                total={selectedRowDataPreview.total}
                notes={selectedRowDataPreview.notes}
                discount={selectedRowDataPreview.discount}
              />

            </div>
          )}
        </div>

        <div className="table-filters flex flex-row items-center justify-between mb-5">
          <div className='text-2xl font-bold font-poppins'>Expenses</div>
        </div>

        <div className="w-full">
          <MaterialReactTable
            enableRowActions
            enableRowSelection
            columns={columns2}
            data={expenseData}
            renderTopToolbarCustomActions={({ table }) => {
              const handleDelete2 = () => {
                const selectedRows = table.getSelectedRowModel().flatRows;

                if (selectedRows.length === 1) {
                  selectedRow = selectedRows[0];
                  const selectedRowId = selectedRow.original.id;
                  setSelectedRow(selectedRow);
                  alert('Deleting Expense with ID: ' + selectedRowId);
                  delete_expense(selectedRowId)

                } else {
                  alert('Please select a single row to delete.');
                }
              };
              const handleEdit2 = () => {
                const selectedRows = table.getSelectedRowModel().flatRows;

                if (selectedRows.length === 1) {
                  const selectedRow = selectedRows[0];
                  selectedRowData = selectedRow.original;
                  setSelectedRowData(selectedRowData);
                  setisNewExpenseFormOpen(true); // Open the form
                } else {
                  alert('Please select a single row to Edit.');
                }
              };


              return (
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <Button
                    color="error"
                    disabled={!table.getIsSomeRowsSelected()}
                    onClick={handleDelete2}
                    variant="contained"
                    sx={employee ? { display: 'none' } : {}}

                  >
                    Delete
                  </Button>
                  <Button
                    color="success"
                    disabled={!table.getIsSomeRowsSelected()}
                    onClick={handleEdit2}
                    variant="contained"
                  >
                    Edit
                  </Button>
                  <Button
                    color="success"
                    variant="contained"
                  >
                    <CSVLink data={data2}>Export to CSV</CSVLink>
                  </Button>
                </div>
              );
            }}
          />
        </div>

      </div>

      {showPopup && (
        <div className="fixed bg-white inset-0 flex items-center overflow-y-auto justify-center z-50">
          <div className="bg-white rounded-lg p-4 shadow-md ">
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 bg-transparent border-5 border-black"
              onClick={togglePopup}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <div style={{
              height: '90vh',
              overflowY: 'auto',
            }}>
              <NewPurchaseForm handleChild={togglePopup} />
            </div>
          </div>
        </div >
      )}

      <NewExpenseForm isOpen={isNewExpenseFormOpen} onClose={closeNewExpenseForm} selectedRowData={selectedRowData} />

    </>
  );
};

export default PurchasesPage;
